<!--
Copyright 2023 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="article-container background">
  <div class="page">
    <angular-editor
      [placeholder]="'Description'"
      [(ngModel)]="mselPage.content"
      [config]="viewConfig"
    ></angular-editor>
  </div>
</div>
